import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import PartSmart from './PartSmart';

interface IStateFromProps {
  isLoggedIn: boolean;
}

const mapStateToProps = (state: any) => ({
  isLoggedIn: state.signin.success
});

export const pureComponent = PartSmart;

export default connect<IStateFromProps, void>(mapStateToProps)(
  withI18n()(PartSmart)
);
